/* tslint:disable */
/* eslint-disable */
/**
 * Enex API
 * API to manage bookings for oil change with Enex
 *
 * The version of the OpenAPI document: v1
 * Contact: jliznaga@linets.cl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BlockSave
 */
export interface BlockSave {
    /**
     * 
     * @type {number}
     * @memberof BlockSave
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BlockSave
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof BlockSave
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BlockSave
     */
    'week_day'?: number;
    /**
     * 
     * @type {string}
     * @memberof BlockSave
     */
    'origin'?: BlockSaveOriginEnum;
    /**
     * 
     * @type {number}
     * @memberof BlockSave
     */
    'object_id': number;
    /**
     * 
     * @type {string}
     * @memberof BlockSave
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlockSave
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BlockSave
     */
    'settings': number;
}

export const BlockSaveOriginEnum = {
    Booking: 'booking',
    Config: 'config'
} as const;

export type BlockSaveOriginEnum = typeof BlockSaveOriginEnum[keyof typeof BlockSaveOriginEnum];


